<template>
  <v-container
    class="settings"
    :class="{'settings--mobile': $_breakpoints_mobile}"
  >
    <v-row>
      <PanelAppBar
        :title="$t('menu.settings')"
      />
    </v-row>
    <v-row>
      <v-col class="settings__title">
        {{ $t('settings.notifications') }}:
      </v-col>
    </v-row>
    <v-row>
      <v-col class="settings__checkbox">
        <v-checkbox
          v-model="notificationsEnabled"
          :label="$t('settings.notification_enable')"
          color="secondary"
          @change="actionBtnsDisabled = false"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="settings__checkbox">
        <v-checkbox
          class="mt-0"
          v-model="soundEnabled"
          :label="$t('settings.sound_enable')"
          color="secondary"
          @change="actionBtnsDisabled = false"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="settings__title pt-5">
        {{ $t('settings.language') }}:
      </v-col>
    </v-row>
    <v-row>
      <v-col class="settings__lang">
        <v-select
          v-model="selectedLang"
          color="secondary"
          :items="languages"
          item-text="lang"
          item-value="locale"
          item-color="secondary"
          return-object
          outlined
          dense
          @change="actionBtnsDisabled = false"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="settings__title pt-5">
        Version: {{ version }}
      </v-col>
    </v-row>
    <v-row
      class="justify-end"
    >
      <v-col class="settings__btn">
        <v-btn
          outlined
          color="secondary"
          :disabled="actionBtnsDisabled"
          @click="cancel()"
        >
          {{ $t('button.cancel') }}
        </v-btn>
      </v-col>
      <v-col class="settings__btn">
        <v-btn
          outlined
          color="secondary"
          :disabled="actionBtnsDisabled"
          @click="apply()"
        >
          {{ $t('button.apply') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PanelAppBar from '@/components/Layout/PanelAppBar.vue'
import { breakpoints } from '@/mixins'
import { version } from '../../autoDialer/constants'

export default {
  components: {
    PanelAppBar,
  },
  mixins: [breakpoints],
  data() {
    return {
      notificationsEnabled: undefined,
      soundEnabled: undefined,
      actionBtnsDisabled: true,
      languages: [
        { lang: `${this.$t('settings.languages.english')}`, locale: 'en' },
        { lang: `${this.$t('settings.languages.italian')}`, locale: 'it' },
        { lang: `${this.$t('settings.languages.spanish')}`, locale: 'es' },
      ],
      selectedLang: {},
      version,
    }
  },
  computed: {
    ...mapGetters('settings', [
      'isNotificationsEnabled',
      'isSoundEnabled',
    ]),
    currentLocale() {
      return this.$i18n.locale
    },
  },
  mounted() {
    this.applyLang()
  },
  methods: {
    ...mapActions('settings', [
      'setNotificationsEnabled',
      'setSoundEnabled',
    ]),
    ...mapActions('snackbar', {
      snackbarShow: 'show',
    }),
    apply() {
      this.setNotificationsEnabled(this.notificationsEnabled)
      this.setSoundEnabled(this.soundEnabled)
      this.$root.$i18n.locale = this.selectedLang.locale
      this.$vuetify.lang.current = this.selectedLang.locale
      this.applyLang()
      this.snackbarShow({ message: this.$t('settings.snackbar.applied') })
      this.actionBtnsDisabled = true
    },
    cancel() {
      this.notificationsEnabled = this.isNotificationsEnabled
      this.soundEnabled = this.isSoundEnabled
      this.applyLang()
      this.actionBtnsDisabled = true
    },
    applyLang() {
      switch (this.currentLocale) {
        case 'it':
          this.selectedLang = { lang: this.$t('settings.languages.italian'), locale: 'it' }
          break
        case 'en':
          this.selectedLang = { lang: this.$t('settings.languages.english'), locale: 'en' }
          break
        case 'sp':
          this.selectedLang = { lang: this.$t('settings.languages.spanish'), locale: 'es' }
          break
        default:
          this.selectedLang = { lang: this.$t('settings.languages.english'), locale: 'en' }
      }
    },
  },
  watch: {
    isNotificationsEnabled: {
      handler(val) {
        this.notificationsEnabled = val
      },
      immediate: true,
    },
    isSoundEnabled: {
      handler(val) {
        this.soundEnabled = val
      },
      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
.settings--mobile {
  height: calc(100vh - 140px);

  @apply overflow-auto;
}

.settings__checkbox {
  @apply p-0;

  ::v-deep .v-label {
    @apply text-sm;
  }
}

.settings__title {
  @apply font-bold p-0;
}

.settings__btn {
  @apply flex-grow-0;

  > button {
    width: 100px;
  }

  ~ .settings__btn {
    @apply pl-0;
  }
}

.settings__lang {
  max-width: 250px;

  @apply px-0 pt-5;
}
</style>
